import React from "react";

import Icon from "../Icon";

// Navegação lateral interna de páginas de edição (abas verticais).
// items: [{ key, name, svg }]
export const SubSidebar = ({ items, active, onChange, className }) => {
    return (
        <nav className={`sub-sidebar ${className ?? ''}`}>
            {items.map(item => (
                <button
                    key={item.key}
                    type="button"
                    className={`sub-sidebar-item${active === item.key ? ' active' : ''}`}
                    onClick={() => onChange(item.key)}
                >
                    {item.svg &&
                        <span className="sub-sidebar-icon">
                            <Icon name={item.svg} size={18} />
                        </span>
                    }
                    <span className="label">{item.name}</span>
                </button>
            ))}
        </nav>
    );
};

export default SubSidebar;
